const MetricPrefix = {
  KILO: 10 ** 3,
  MEGA: 10 ** 6,
  GIGA: 10 ** 9,
  TERA: 10 ** 12,
  PETA: 10 ** 15,
  EXA: 10 ** 18,
};
export default MetricPrefix;
